import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "@dreamchimney/react-axios";
import { apiConfig } from "~/api/apiConfig";
import SidebarTile from "~/Components/SidebarTile";

import "./WideSidebar.less";

const RESERVED = new Set(["about", "search", "recent", "submit", "tag", "profile", "edit"]);

const WideSidebar = () => {
  const { pathname } = useLocation();
  const [recent, setRecent] = useState([]);
  const [related, setRelated] = useState([]);

  const segment = pathname.replace(/^\//, "").split("/")[0];
  const isHome = pathname === "/" || pathname === "";
  const isDetail = Boolean(segment && !RESERVED.has(segment) && pathname.split("/").filter(Boolean).length === 1);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const recentUrl = isHome
        ? `${apiConfig.oftheday.recent}?filter=exclude_today&page=1`
        : `${apiConfig.oftheday.recent}?page=1`;
      const recentRes = await axios.get(recentUrl);
      const recentPosts = (recentRes.data && recentRes.data.posts) || [];
      const filteredRecent = recentPosts
        .filter((post) => {
          if (isHome && (post.date === "Today" || post.date === "today")) return false;
          if (isDetail && post.slug === segment) return false;
          return true;
        })
        .slice(0, 5);
      if (!cancelled) {
        setRecent(filteredRecent);
      }

      let seedId = null;
      if (isDetail) {
        try {
          const detail = await axios.get(`${apiConfig.oftheday.detail}?otd_slug=${segment}`);
          seedId = detail.data && detail.data.posts && detail.data.posts[0] && detail.data.posts[0].id;
        } catch (e) {
          seedId = null;
        }
      } else if (isHome) {
        const today = await axios.get(apiConfig.oftheday.today);
        seedId = today.data && today.data.posts && today.data.posts[0] && today.data.posts[0].id;
      }

      if (seedId) {
        const rel = await axios.get(`${apiConfig.oftheday.related}/${seedId}`);
        const posts = ((rel.data && rel.data.posts) || [])
          .filter((post) => !isHome || (post.date !== "Today" && post.date !== "today"))
          .slice(0, 6);
        if (!cancelled) {
          setRelated(posts);
        }
      } else if (!cancelled) {
        setRelated([]);
      }
    };

    load().catch(() => {
      if (!cancelled) {
        setRelated([]);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [pathname, isDetail, isHome, segment]);

  if (!recent.length && !related.length) {
    return null;
  }

  return (
    <aside className="wideSidebar">
      {recent.length > 0 && (
        <div className="wideSidebarBlock">
          <div className="wideSidebarTitle">Recent</div>
          {recent.map((post) => (
            <SidebarTile key={post.id} post={post} />
          ))}
          <Link className="wideSidebarMore" to="/recent">
            More recent
          </Link>
        </div>
      )}
      {related.length > 0 && (
        <div className="wideSidebarBlock">
          <div className="wideSidebarTitle">Related</div>
          {related.map((post) => (
            <SidebarTile key={post.id} post={post} />
          ))}
        </div>
      )}
    </aside>
  );
};

export default WideSidebar;
